import TermlyCookieBanner from '@m/components/TermlyCookieBanner/TermlyCookieBanner';
import Providers from '@m/providers';

import Customer from './Customer';
import { CustomerGlobalStyle } from './CustomerApp.styled';

export default function App() {
  return (
    <Providers>
      <TermlyCookieBanner />
      <CustomerGlobalStyle />
      <Customer />
    </Providers>
  );
}
